import * as components from './components'

export default [
  {
    path: '/profile',
    component: components.Profile,
    children: [
      {
        path: 'settings',
        component: components.Settings,
        name: 'profile'
      },
      {
        path: 'change_password',
        component: components.ChangePassword,
        name: 'change_password'
      }
    ]
  }
]
